import { useMemo } from "react";

import { useAccountStore, useUserStore } from "base/stores";

import { ENVIRONMENT_TYPES } from "@base/common/constants/account.constants.js";

export function useSandbox() {
  const sandbox = useUserStore.getState().sandbox;
  const currentEnv = useMemo(
    function getSandboxAccounts() {
      return sandbox.find((env) => env._id === useAccountStore.getState()._id);
    },
    [sandbox]
  );
  return (
    currentEnv || {
      Type: ENVIRONMENT_TYPES.PRODUCTION
    }
  );
}
